import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const styles = {
  root: { margin: 0, textAlign: "center" },
  avatar: {
    borderRadius: "50%",
    height: "56px",
    width: "56px"
  },
  avatarButton: {
    backgroundColor: "transparent"
  }
};

class Badge extends Component {
  render() {
    const { classes, name, value, image, onClick } = this.props;
    return (
      <div className={classes.root}>
        <Button
          variant="fab"
          className={classes.avatarButton}
          onClick={() => onClick(value)}
        >
          <img className={classes.avatar} src={image} alt={name} />
        </Button>
        <div>{name}</div>
      </div>
    );
  }
}

Badge.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(Badge);



// WEBPACK FOOTER //
// ./src/Ambassadors/atoms/Badge.js